import common from './common';
import header from './header';
import sidebar from './sidebar';
import language from './language';
import login from './login';
import mypage from './mypage';
import pages from './pages';
import components from './components';

const vi = {
  common,
  header,
  sidebar,
  language,
  login,
  mypage,
  pages,
  components,
};

export default vi;
